import objectPath from "object-path";
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Brand } from "../brand/Brand";
import { AdminAsideMenu } from "./aside-menu/AdminAsideMenu";

export function AdminAside({ isMinimized, onMenuMinimize }) {
   const uiService = useHtmlClassService();
   //  const location = useLocation();
   const layoutProps = useMemo(() => {
      return {
         disableScroll: objectPath.get(uiService.config, "aside.menu.dropdown") === "true" || false,
         isAdminLayout: true,
         asideClassesFromConfig: uiService.getClasses("aside", true),
         disableAsideSelfDisplay: objectPath.get(uiService.config, "aside.self.display") === false,
         headerLogo: uiService.getLogo()
      };
   }, [uiService]);

   // The toggle moves while the sidebar animates, so its tooltip closes on
   // click instead of staying behind where the button was.
   const [isToggleTooltipOpen, setIsToggleTooltipOpen] = useState(false);

   const toggleMinimized = () => {
      setIsToggleTooltipOpen(false);
      onMenuMinimize(!isMinimized);
   };

   return (
      <>
         {/* begin::Aside */}
         <div
            id="kt_aside"
            className={`aside aside-left aside-admin ${
               layoutProps.asideClassesFromConfig
            } d-flex flex-column flex-row-auto admin-aside ${isMinimized ? "minimized" : ""}`}
         >
            <div className="aside-brand-row d-flex align-items-center">
               <Brand />
               <Tooltip
                  title={isMinimized ? "Expand the menu" : "Collapse the menu to icons"}
                  placement="right"
                  overlayClassName="aside-desktop-tooltip"
                  open={isToggleTooltipOpen}
                  onOpenChange={setIsToggleTooltipOpen}
               >
                  <button
                     type="button"
                     className="aside-minimize-toggle"
                     aria-label={isMinimized ? "Expand the menu" : "Collapse the menu to icons"}
                     aria-expanded={!isMinimized}
                     onClick={toggleMinimized}
                  >
                     {isMinimized ? <RightOutlined /> : <LeftOutlined />}
                  </button>
               </Tooltip>
            </div>

            {/* begin::Aside Menu */}
            <div
               id="kt_aside_menu_wrapper"
               className="aside-menu-left aside-menu-wrapper flex-column-fluid"
            >
               {layoutProps.disableAsideSelfDisplay && (
                  <>
                     {/* begin::Header Logo */}
                     <div className="header-logo">
                        <Link to="">
                           <img alt="logo" src={layoutProps.headerLogo} />
                        </Link>
                     </div>
                     {/* end::Header Logo */}
                  </>
               )}
               <AdminAsideMenu
                  disableScroll={layoutProps.disableScroll}
                  isMinimized={isMinimized}
               />
            </div>
            {/* end::Aside Menu */}
         </div>
         {/* end::Aside */}
      </>
   );
}
